import { ISnotrRoute } from '..';

export default [
  {
    path: '/occupations',
    name: 'Occupations',
    meta: {
      title: 'TabTitle.occupations',
      applicationMode: 'PaycheckMode',
    },
    component: () => import('@/pages/occupations.vue'),
  },
] as ISnotrRoute[];
